import {
  ColumnDefinitionModel,
  PipeDefinitionModel,
} from '@app/shared/models/column-definition.model';
import { TableColumnsConfigModel } from './table-columns-config.model';
import { TableColumnsConfigKey } from './table-columns-config-key.model';
import { InvoiceModel } from '../invoices/invoice.model';
import { ColumnDefinitionPredefined } from '@app/shared/models/column-definition-predefined.model';
import * as _ from 'lodash';
export class TableColumnsConfigHelper {
  private configurations: TableColumnsConfigModel[];

  constructor() {
    const datePipe = new PipeDefinitionModel('datePipe', 'dd/MM/yyyy');
    const dateTimePipe = new PipeDefinitionModel(
      'datePipe',
      'dd/MM/yyyy HH:mm:ss'
    );
    const moneyPipe = new PipeDefinitionModel(
      'moneyPipe',
      null,
      (invoice: InvoiceModel) => invoice.Currency
    );
    const moneyPipeExport = new PipeDefinitionModel('moneyPipe', {
      compactFormat: true,
    });
    const nullableBooleanPipe = new PipeDefinitionModel('nullableBooleanPipe');
    const booleanPipe = new PipeDefinitionModel('booleanPipe');
    const delayPipe = new PipeDefinitionModel('delayPipe');
    const invoiceStatePipe = new PipeDefinitionModel('statePipe');
    const joinListPipe = new PipeDefinitionModel('joinListPipe', '2');
    const joinListPipeExport = new PipeDefinitionModel('joinListPipe');
    const activityOperation = new PipeDefinitionModel('activityOperation');
    const activityDomaine = new PipeDefinitionModel('activityDomaine');

    this.configurations = [
      {
        key: TableColumnsConfigKey.WORKFLOW,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Nom', 'Name', true),
          new ColumnDefinitionModel(
            3,
            'Groupe opérationnel',
            'OperationalGroupName',
            true
          ),
          new ColumnDefinitionModel(
            4,
            'Groupe comptabilité',
            'NonErpGroupName',
            true
          ),
          new ColumnDefinitionModel(
            5,
            'Date',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(6, 'Actif', 'IsActive', true),
        ],
      },
      {
        key: TableColumnsConfigKey.APPROVAL,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Nom', 'Name', true),
          new ColumnDefinitionModel(
            3,
            'Groupe opérationnel',
            'OperationalGroupName',
            true
          ),
          new ColumnDefinitionModel(
            5,
            'Date',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            6,
            'Actif',
            'IsActive',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.WORKFLOW_PROMOTION,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Nom', 'Name', true),
          new ColumnDefinitionModel(
            3,
            'Groupe opérationnel',
            'OperationalGroupName',
            true
          ),
          new ColumnDefinitionModel(
            5,
            'Date',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(6, 'Actif', 'IsActive', true),
        ],
      },
      {
        key: TableColumnsConfigKey.USER,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Nom', 'LastName', true),
          new ColumnDefinitionModel(3, 'Prénom', 'FirstName', true),
          new ColumnDefinitionModel(4, 'Email', 'Email', true),
          new ColumnDefinitionModel(
            5,
            'Date',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(6, 'Sourcing', 'Sourcing', true),
          new ColumnDefinitionModel(
            7,
            'Actif',
            'IsActive',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.GROUP,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Nom',
            'Name',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(3, 'Type', 'Type', true),
          new ColumnDefinitionModel(4, 'Marque', 'CompanyLabel', true),
          new ColumnDefinitionModel(5, 'Typologie', 'TypologyLabel', true),
          new ColumnDefinitionModel(6, 'Métier', 'ProfessionType', true),
          new ColumnDefinitionModel(7, 'Référent', 'SupervisorUser', true),
          new ColumnDefinitionModel(
            8,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            nullableBooleanPipe
          ),
          new ColumnDefinitionModel(
            9,
            'Facture AGI',
            'CanManageInvoiceAGI',
            true,
            true,
            true,
            null,
            false,
            nullableBooleanPipe
          ),
          new ColumnDefinitionModel(
            10,
            'Création dans PPR',
            'CanCreateInPPR',
            true,
            true,
            true,
            null,
            false,
            nullableBooleanPipe
          ),
          new ColumnDefinitionModel(
            11,
            'Prescripteur',
            'IsPrescriptorGroup',
            true,
            true,
            true,
            null,
            false,
            nullableBooleanPipe
          ),
          new ColumnDefinitionModel(
            12,
            'Actif',
            'IsActive',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.RECIPIENTENTITY,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Nom', 'Name', true),
          new ColumnDefinitionModel(
            3,
            'Groupe opérationnel',
            'OperationalGroupName',
            true
          ),
          new ColumnDefinitionModel(
            4,
            'Groupe supervision',
            'SupervisionGroups',
            true,
            true,
            true,
            null,
            false,
            joinListPipe,
            joinListPipeExport
          ),
          new ColumnDefinitionModel(
            5,
            'Groupe de consultation',
            'ObservationGroupName',
            true
          ),
          new ColumnDefinitionModel(
            6,
            'Actif',
            'IsActive',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.ASSET,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Type', 'TypeName', true),
          new ColumnDefinitionModel(3, 'Référence', 'Reference', true),
          new ColumnDefinitionModel(4, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(
            5,
            'Groupe opérationnel ',
            'OperationalGroupName',
            true
          ),
          new ColumnDefinitionModel(
            6,
            'Actif',
            'IsActive',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.EMAILTEMPLATE,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Label', 'Label', true),
          new ColumnDefinitionModel(3, 'Type', 'TypeName', true),
          new ColumnDefinitionModel(4, 'Objet', 'Title', true),
          new ColumnDefinitionModel(
            5,
            'Contenu',
            'Content',
            true,
            true,
            true,
            null,
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICEREJECTED,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Type rejet', 'RejectionFlag', true),
          new ColumnDefinitionModel(
            3,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(4, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            5,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            6,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            7,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            9,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            10,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            11,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(12, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(
            13,
            'Société Métadonnées',
            'SupplierRecipientName',
            true
          ),
          new ColumnDefinitionModel(
            14,
            'Référent',
            'CurrentAssignmentGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'Prise en charge',
            'PickedByUser',
            true
          ),
          new ColumnDefinitionModel(
            16,
            'Commentaire',
            'LastForwardComment',
            true
          ),
          new ColumnDefinitionModel(
            17,
            'ST',
            'IsWorkingSituation',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            18,
            'RF',
            'IsReverseFactoring',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            19,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(
            20,
            'PPR',
            'IsPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICEDISPATCHED,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(
            3,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            4,
            'PPR',
            'IsPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(5, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            6,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            7,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            9,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            10,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            11,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            12,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(13, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(
            14,
            'Référent',
            'CurrentAssignmentGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            15,
            "Groupe d'affectation",
            'CurrentAssignmentGroupName',
            true
          ),
          new ColumnDefinitionModel(
            16,
            'ST',
            'IsWorkingSituation',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            17,
            'RF',
            'IsReverseFactoring',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            18,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(
            19,
            'Code ERP Sage',
            'SupplierSageErpCode',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            20,
            'Facture contrôlée',
            'CheckedByUser',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            21,
            'Raison refus',
            'CommentReturnOperationnal',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(
            22,
            'Date prévisionnelle',
            'EstimatedActDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICECONTROL,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(
            3,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(4, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            5,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            6,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            7,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            9,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            10,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            11,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(12, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(
            13,
            'Référent',
            'CurrentAssignmentGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            14,
            "Groupe d'affectation",
            'CurrentAssignmentGroupName',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'ST',
            'IsWorkingSituation',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            16,
            'RF',
            'IsReverseFactoring',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            17,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(
            18,
            'Code ERP Sage',
            'SupplierSageErpCode',
            true,
            true,
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.WAITING,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(
            3,
            'Raison de la mise en attente',
            'WaitingFlag',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(
            3,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            4,
            'PPR',
            'IsPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(5, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            6,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            7,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            10,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            11,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            12,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            13,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(14, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(
            15,
            'Référent',
            'CurrentAssignmentGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            16,
            "Groupe d'affectation",
            'CurrentAssignmentGroupName',
            true
          ),
          new ColumnDefinitionModel(
            17,
            'ST',
            'IsWorkingSituation',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            18,
            'RF',
            'IsReverseFactoring',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            19,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(
            20,
            'Code ERP Sage',
            'SupplierSageErpCode',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            21,
            'Nom assistante',
            'OperationAssistantName',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            22,
            'Code famille',
            'FamilyLabel',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(
            23,
            'Corps de métier',
            'TradeCodeLabel',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            24,
            'Tentative création PPR',
            'InvoiceLastPPRLogUserName',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            25,
            'Compteur Historique erreurs PPR',
            'InvoicePPRLogsErrorCount',
            true,
            true,
            true,
            'center-align'
          ),
          new ColumnDefinitionModel(
            26,
            'Erreur PPR',
            'InvoiceLastPPRLog',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICESEARCH,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Statut',
            'State',
            true,
            true,
            true,
            null,
            false,
            invoiceStatePipe,
            null,
            true
          ),
          new ColumnDefinitionModel(
            3,
            'Type',
            'TypeName',
            true,
            true,
            true,
            null
          ),
          new ColumnDefinitionModel(
            4,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            5,
            'PPR',
            'IsPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            6,
            'Nom fournisseur',
            'SupplierCompanyName',
            true
          ),
          new ColumnDefinitionModel(7, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            8,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            9,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            10,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            11,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            12,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            13,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            14,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'Société',
            'RecipientEntityName',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            16,
            'Référent',
            'CurrentAssignmentGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            17,
            'Valideur opérationnel',
            'ProcessedByUser',
            true
          ),
          new ColumnDefinitionModel(
            18,
            'Date validation opérationnelle',
            'ProcessedAt',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            19,
            'Workflow',
            'Workflow.Name',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            20,
            'Valideur 1',
            'InvoiceWorkflowStageValidators.FirstValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            21,
            'Date validation 1',
            'InvoiceWorkflowStageValidators.FirstValidation',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            22,
            'Valideur 2',
            'InvoiceWorkflowStageValidators.SecondValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            23,
            'Date validation 2',
            'InvoiceWorkflowStageValidators.SecondValidation',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            24,
            'Valideur 3',
            'InvoiceWorkflowStageValidators.ThirdValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            25,
            'Date validation 3',
            'InvoiceWorkflowStageValidators.ThirdValidation',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            26,
            'Valideur comptable',
            'VoucherValidatedByUser',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            27,
            'Date validation comptable',
            'VoucherValidatedAt',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            28,
            'Litige',
            'IsComplaint',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            30,
            'ST',
            'IsWorkingSituation',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            31,
            'RF',
            'IsReverseFactoring',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            33,
            'Code Projet',
            'VoucherAnalyticalCode',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            34,
            'Direction',
            'VoucherDepartment',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            35,
            'Section analytique',
            'VoucherAnalyticalSection',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            36,
            'Commentaires',
            'VoucherComment',
            true,
            true,
            true,
            null,
            null,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(
            37,
            'Code ERP Sage',
            'SupplierSageErpCode',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(38, 'Cle PPM', 'ClePPM', true, true, true),
          new ColumnDefinitionModel(
            39,
            'Date règlement',
            'PaidDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            40,
            'Corps de métier',
            'TradeLabel',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            41,
            'Code famille',
            'FamilyLabel',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICELATEGRP,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'GroupId',
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(1, 'Groupe', 'GroupName', true),
          new ColumnDefinitionModel(
            2,
            'Nombre de factures',
            'InvoicesCount',
            true
          ),
          new ColumnDefinitionModel(3, 'Type', 'GroupTypeName', true),
          new ColumnDefinitionModel(4, 'Référent', 'SupervisorName', true),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICELATEINVOICES,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            1,
            'Retard',
            'Delay',
            true,
            true,
            true,
            null,
            false,
            delayPipe
          ),
          new ColumnDefinitionModel(
            2,
            'Statut',
            'State',
            true,
            true,
            true,
            null,
            false,
            invoiceStatePipe
          ),
          new ColumnDefinitionModel(
            3,
            'Nom fournisseur',
            'SupplierCompanyName',
            false,
            true
          ),
          new ColumnDefinitionModel(4, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            5,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            6,
            'PPR',
            'IsPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            7,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            9,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            10,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            11,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            12,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(13, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(
            14,
            'Référent',
            'CurrentAssignmentGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'ST',
            'IsWorkingSituation',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            16,
            'RF',
            'IsReverseFactoring',
            true,
            true,
            true,
            'bit-flag-cell',
            false,
            booleanPipe
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICEVOUCHERVALIDATED,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            "Groupe d'affectation",
            'CurrentAssignmentGroupName',
            true
          ),
          new ColumnDefinitionModel(
            3,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(4, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            5,
            'Société facturée',
            'RecipientEntityName',
            true
          ),
          new ColumnDefinitionModel(
            6,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            7,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            9,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            10,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            11,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(
            12,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            13,
            'Valideur opérationnel',
            'ProcessedByUser',
            true
          ),
          new ColumnDefinitionModel(
            14,
            'Date validation opérationnelle',
            'ProcessedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            15,
            'Date fin circuit de validation',
            'WorkflowCompletionDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            16,
            'Dernier valideur',
            'InvoiceWorkflowStageValidators.LastValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            17,
            'Groupe comptabilité',
            'Workflow.NonErpGroupName',
            true
          ),
          new ColumnDefinitionModel(
            18,
            'Référent',
            'Workflow.NonErpGroupSupervisorName',
            true
          ),
          new ColumnDefinitionModel(
            19,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(
            20,
            'Code ERP Sage',
            'SupplierSageErpCode',
            true,
            true,
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICEVOUCHERWORKFLOW,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            "Groupe d'affectation",
            'CurrentAssignmentGroupName',
            true
          ),
          new ColumnDefinitionModel(
            3,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(4, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            5,
            'Société facturée',
            'RecipientEntityName',
            true
          ),
          new ColumnDefinitionModel(6, 'Référent', 'Referent', true),
          new ColumnDefinitionModel(
            7,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            8,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            9,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            10,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            11,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(
            12,
            'Valideur opérationnel',
            'ProcessedByUser',
            true
          ),
          new ColumnDefinitionModel(
            13,
            'Valideur 1',
            'InvoiceWorkflowStageValidators.FirstValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            14,
            'Valideur 2',
            'InvoiceWorkflowStageValidators.SecondValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICEPROMOTIONWORKFLOW,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            2,
            "Groupe d'affectation",
            'CurrentAssignmentGroupName',
            true
          ),
          new ColumnDefinitionModel(
            3,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(
            4,
            'Code Tiers Evalua',
            'SupplierMdmId',
            true
          ),
          new ColumnDefinitionModel(5, 'SIRET', 'SupplierSiret', true),
          new ColumnDefinitionModel(6, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            7,
            'Société facturée',
            'RecipientEntityName',
            true
          ),
          new ColumnDefinitionModel(8, 'Référent', 'Referent', true),
          new ColumnDefinitionModel(
            9,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            10,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            11,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            12,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            13,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(
            14,
            'Valideur opérationnel',
            'ProcessedByUser',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'Situation',
            'IsWorkingSituation',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            16,
            'Litige',
            'IsComplaint',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            17,
            'Raison Litige',
            'ComplaintComment',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(
            18,
            'Valideur 1',
            'InvoiceWorkflowStageValidators.FirstValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            19,
            'Valideur 2',
            'InvoiceWorkflowStageValidators.SecondValidatorUser',
            true
          ),
          new ColumnDefinitionModel(
            20,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(
            21,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            22,
            'Type',
            'TypeName',
            true,
            true,
            true,
            null
          ),
          new ColumnDefinitionModel(
            23,
            'Raison retour niveau 1',
            'CommentReturnFirstLevel',
            true,
            true,
            true,
            null,
            false,
            null,
            null,
            true
          ),
          new ColumnDefinitionModel(
            24,
            'En erreur PPR',
            'InvoiceIsInErrorPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            25,
            'Erreur PPR',
            'InvoiceLastPPRLog',
            true,
            true,
            true,
            null,
            null,
            null,
            null,
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.GROUPUSERS,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(2, 'Nom', 'LastName', true),
          new ColumnDefinitionModel(3, 'Prénom', 'FirstName', true),
          new ColumnDefinitionModel(4, 'Email', 'Email', true),
          new ColumnDefinitionModel(
            5,
            'Date de création',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            6,
            'Sourcing',
            'SourcingLinkWithGroup',
            true
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.IMPORTHISTORY,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            1,
            'Date',
            'ImportDate',
            true,
            false,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(2, 'Fichiers', 'FilesCount', true),
          new ColumnDefinitionModel(3, 'Erreurs', 'Errors', true),
          new ColumnDefinitionModel(
            4,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
          new ColumnDefinitionModel(5, 'Type erreurs', 'ErrorType', true),
        ],
      },
      {
        key: TableColumnsConfigKey.IMPORTHISTORYDETAIL,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(
            1,
            'Id Métadata',
            'OcrMetadataId',
            true,
            false,
            true,
            null,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Facture',
            'IsOcrMetadataImported',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(3, 'Fichier JSON', 'JsonFileName', true),
          new ColumnDefinitionModel(4, 'Fichier PDF', 'PdfFileName', true),
          new ColumnDefinitionModel(
            5,
            'Valide',
            'IsValid',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(6, 'Récupération', 'RecoveryDate', true),
          new ColumnDefinitionModel(7, 'Erreur', 'ErrorType', true),
          new ColumnDefinitionModel(
            8,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.ACTIVITYLOGS,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false,
            false
          ),
          new ColumnDefinitionModel(1, 'Id du log', 'Id', true, false, false),
          new ColumnDefinitionModel(
            2,
            'Date',
            'Date',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            3,
            'Domaine',
            'TableName',
            true,
            true,
            true,
            null,
            false,
            activityDomaine
          ),
          new ColumnDefinitionModel(4, 'Utilisateur', 'User', true),
          new ColumnDefinitionModel(
            5,
            "Type d'opération",
            'OperationType',
            true,
            true,
            true,
            null,
            false,
            activityOperation
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.FAULTEDINVOICES,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Statut actuel',
            'State',
            true,
            true,
            true,
            null,
            false,
            invoiceStatePipe
          ),
          new ColumnDefinitionModel(
            3,
            'Statut attendu',
            'ExpectedState',
            true,
            true,
            true,
            null,
            false,
            invoiceStatePipe
          ),
          new ColumnDefinitionModel(
            4,
            'Type',
            'TypeName',
            true,
            true,
            true,
            null
          ),
          new ColumnDefinitionModel(
            5,
            'BAP',
            'IsVoucher',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            6,
            'PPR',
            'IsPPR',
            true,
            true,
            true,
            null,
            false,
            booleanPipe
          ),
          new ColumnDefinitionModel(
            7,
            'Nom fournisseur',
            'SupplierComputedCompanyName',
            true
          ),
          new ColumnDefinitionModel(8, 'Numéro facture', 'Number', true),
          new ColumnDefinitionModel(
            9,
            'Date facture',
            'IssuedAt',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            10,
            'Date échéance',
            'DueDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            11,
            'Date réception',
            'CreationDate',
            true,
            true,
            true,
            null,
            false,
            datePipe
          ),
          new ColumnDefinitionModel(
            12,
            'Montant HT',
            'AmountTaxExcluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            13,
            'Montant TTC',
            'AmountTaxIncluded',
            true,
            true,
            true,
            'money-cell',
            false,
            moneyPipe,
            moneyPipeExport
          ),
          new ColumnDefinitionModel(
            14,
            'Réf client 1',
            'PrimaryReference',
            true
          ),
          new ColumnDefinitionModel(
            15,
            'Réf client 2',
            'SecondaryReference',
            true
          ),
          new ColumnDefinitionModel(16, 'Société', 'RecipientEntityName', true),
          new ColumnDefinitionModel(17, 'Type rejet', 'RejectionFlag', true),
          new ColumnDefinitionModel(18, 'Correction', 'RecyclingFlag', true),
        ],
      },
      {
        key: TableColumnsConfigKey.MISSINGINVOICENUMBERS,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.SELECT,
            'Selection',
            'Id',
            true,
            false
          ),
          new ColumnDefinitionModel(
            ColumnDefinitionPredefined.ACTIONS,
            'Action',
            'Action',
            true,
            false
          ),
          new ColumnDefinitionModel(
            2,
            'Traité',
            'PickedByUserName',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            3,
            'Date du traitement',
            'PickedAt',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            4,
            'Nom du document',
            'PdfFileName',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            5,
            'Date de réception',
            'ImportDate',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            6,
            'Date OCR',
            'OcrDate',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            7,
            'Type',
            'InvoiceTypeLabel',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            8,
            'Commentaire ',
            'Comment',
            true,
            true,
            true
          ),
          new ColumnDefinitionModel(
            9,
            'Indication',
            'Indication',
            true,
            true,
            false
          ),
        ],
      },
      {
        key: TableColumnsConfigKey.INVOICEMODALPPRLOGS,
        ColumnsDefinition: [
          new ColumnDefinitionModel(
            1,
            'Date',
            'CreatedAt',
            true,
            true,
            true,
            null,
            false,
            dateTimePipe
          ),
          new ColumnDefinitionModel(
            2,
            'Utilisateur',
            'RequestedByUserName',
            true,
            true,
            true,
            null
          ),
          new ColumnDefinitionModel(
            3,
            'Message',
            'Label',
            true,
            true,
            true,
            'big-content-cell',
            false
          ),
          new ColumnDefinitionModel(
            4,
            'Assistante',
            'AssistantName',
            true,
            true,
            true
          ),
        ],
      },
    ];
  }

  public getColumnsDefinition(key: string): Array<ColumnDefinitionModel> {
    return _.find(
      this.configurations,
      (config) => config.key.toLowerCase() === key.toLowerCase()
    ).ColumnsDefinition;
  }
}
